export enum DimensionType {
  Hierarchy,
  CalendarAQMW, // Annual Quarter Month Week
  CalendarAQM, // Annual Quarter Month 
  CalendarAnnual,
  CalendarWeek,
  BaseIndexAQMW, // Annual Quarter Month Week
  BaseIndexAQM, // Annual Quarter Month
  BaseIndexAnnual,
  Configuration = 1000
}

export interface IDimension {
  id: string;
  name: string;
  type: DimensionType,
  hierarchy: string,
  selection?: string[],
  displaySelection?: string[],
  displayValue?: string[],
}